var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-popup",
    {
      staticClass: "calendar-event-dialog",
      attrs: { title: _vm.event.title, active: _vm.isVisible },
      on: {
        "update:active": function ($event) {
          _vm.isVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "event-details-container" }, [
        _vm.event.status
          ? _c(
              "div",
              { staticClass: "status-header" },
              [
                _c(
                  "b-badge",
                  {
                    staticClass: "status-badge",
                    attrs: { variant: _vm.statusColor, pill: "" },
                  },
                  [_vm._v(" " + _vm._s(_vm.event.status.label) + " ")]
                ),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "details-section" }, [
          _c("div", { staticClass: "detail-item" }, [
            _c(
              "div",
              { staticClass: "icon-wrapper bg-blue-50" },
              [
                _c("feather-icon", {
                  staticClass: "detail-icon text-primary",
                  attrs: { icon: "HomeIcon" },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "detail-content" }, [
              _c("span", { staticClass: "detail-label" }, [
                _vm._v("Instituição"),
              ]),
              _c("span", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.event.legal_entity_name)),
              ]),
            ]),
          ]),
          _vm.event.address
            ? _c("div", { staticClass: "detail-item" }, [
                _c(
                  "div",
                  { staticClass: "icon-wrapper bg-red-50" },
                  [
                    _c("feather-icon", {
                      staticClass: "detail-icon text-danger",
                      attrs: { icon: "MapPinIcon" },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "detail-content" }, [
                  _c("span", { staticClass: "detail-label" }, [
                    _vm._v("Endereço"),
                  ]),
                  _c("span", { staticClass: "detail-value" }, [
                    _vm._v(_vm._s(_vm.event.address)),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "detail-item" }, [
            _c(
              "div",
              { staticClass: "icon-wrapper bg-purple-50" },
              [
                _c("feather-icon", {
                  staticClass: "detail-icon text-purple-600",
                  attrs: { icon: "CalendarIcon" },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "detail-content" }, [
              _c("span", { staticClass: "detail-label" }, [_vm._v("Data")]),
              _c("span", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.formatDate(_vm.event.startDate))),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "detail-item" }, [
            _c(
              "div",
              { staticClass: "icon-wrapper bg-green-50" },
              [
                _c("feather-icon", {
                  staticClass: "detail-icon text-success",
                  attrs: { icon: "ClockIcon" },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "detail-content" }, [
              _c("span", { staticClass: "detail-label" }, [_vm._v("Horário")]),
              _c("span", { staticClass: "detail-value" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.formatTime(_vm.event.startDate)) +
                    " - " +
                    _vm._s(_vm.formatTime(_vm.event.endDate)) +
                    " "
                ),
              ]),
            ]),
          ]),
        ]),
        _vm.canShowActions
          ? _c(
              "div",
              { staticClass: "actions-section mt-4" },
              [
                _vm.canConfirmEvent
                  ? _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: _vm.getPermission("confirm"),
                            expression: "getPermission('confirm')",
                          },
                        ],
                        staticClass: "action-button action-button-confirm",
                        attrs: { variant: "success" },
                        on: { click: _vm.handleConfirm },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "action-icon",
                          attrs: { icon: "CheckCircleIcon" },
                        }),
                        _c("span", { staticClass: "action-text" }, [
                          _vm._v(_vm._s(_vm.$t("lesson.confirm_completion"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.canRescheduleEvent
                  ? _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: _vm.getPermission("reschedule"),
                            expression: "getPermission('reschedule')",
                          },
                        ],
                        staticClass: "action-button action-button-reschedule",
                        attrs: { variant: "primary" },
                        on: { click: _vm.handleReschedule },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "action-icon",
                          attrs: { icon: "CalendarIcon" },
                        }),
                        _c("span", { staticClass: "action-text" }, [
                          _vm._v(_vm._s(_vm.$t("lesson.reschedule"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.canCancelEvent
                  ? _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: _vm.getPermission("cancel"),
                            expression: "getPermission('cancel')",
                          },
                        ],
                        staticClass: "action-button action-button-cancel",
                        attrs: { variant: "danger" },
                        on: { click: _vm.handleCancel },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "action-icon",
                          attrs: { icon: "XCircleIcon" },
                        }),
                        _c("span", { staticClass: "action-text" }, [
                          _vm._v(_vm._s(_vm.$t("lesson.cancel_schedule"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }